import React from 'react';

class Slide3 extends React.Component {
    constructor(props) {
        super(props);
        this.slide3 = React.createRef();
        this.handleScroll = this.handleScroll.bind(this);
        this.disableIosTextFieldZoom = this.disableIosTextFieldZoom.bind(this);
        this.minSavingsValue = 2000;
        this.savingsInputTimer = null;
        this.state = {
            collapseOpen: false,
            visible: false,
            currentAge: '',
            retireAge: 65,
            leavingReason: 1,
            gender: '',
            withdrawalYear: '',
            rawCurrentInvestment: 0,
            rawVestedInvestment: 0,
            rawVestedHarmonisedInvestment: 0,
            rawSavingsInvestment: 0,
            currentInvestment: '',
            vestedInvestment: '',
            vestedHarmonisedInvestment: '',
            savingsInvestment: '',
            rawSalaryValue: 0,
            salaryValue: '',
            withDrawalYearNextError: false,
            withDrawalYearMinError: false,
            withDrawalYearMinNote: false,  
            withDrawlYearEagerValidation: false,
            formValid: false,
            bsTemplate: '<div class="popover in"></div>',
            dropContent: [
                { value: 0, text: "Select a reason below" },
                { value: 1, text: "Resignation" },
                { value: 2, text: "Dismissal" },
                { value: 3, text: "Retrenchment" }
            ]
        };
    }
    componentDidMount() {
        this.props.custScrollTo(this.slide3.current)
        $('[data-toggle="popover"]').popover()
        $(".fade").addClass("in")
        var customSelect = $('.c-custom-select');
        $(document).on("click", ".popover .slide3__popover-cancel", function () {
            $(this).parents(".popover").popover('hide');
        });

        // Options for custom Select
        jcf.setOptions('Select', {
            wrapNative: false,
            wrapNativeOnMobile: false,
            fakeDropInBody: false,
            maxVisibleItems: 4
        });

        jcf.replace(customSelect);

        window.addEventListener('scroll', this.handleScroll);

        this.disableIosTextFieldZoom();
    }


    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    handleScroll() {
        let view = this.slide3.current.getBoundingClientRect();
        const Buffer = 5
        if (view.top <= Buffer) this.setState({ visible: true });
        if (this.state.visible && (view.top >= window.innerHeight / 2)) {
            this.props.closeSlide();
        }
    }

    toggleCollapse() {
        this.setState({ collapseOpen: !this.state.collapseOpen })
    }


    disableIosTextFieldZoom() {

        const checkIsIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

        if (!checkIsIOS) return;

        const el = document.querySelector('meta[name=viewport]');

        if (el !== null) {
            let content = el.getAttribute('content');
            let re = /maximum\-scale=[0-9\.]+/g;

            if (re.test(content)) {
                content = content.replace(re, 'maximum-scale=1.0');
            } else {
                content = [content, 'maximum-scale=1.0'].join(', ')
            }

            el.setAttribute('content', content);
        }
    }

    handleInvestmentValue(e, rawInvestmentVar, investmentVar) {    
        
        // on savings component input
        // wait for timeout before enabling eager validation messages 
        if (rawInvestmentVar === 'rawSavingsInvestment' && !this.state.withDrawlYearEagerValidation) {
            clearTimeout(this.savingsInputTimer);
            this.savingsInputTimer = setTimeout(()=>{
                this.setState({ withDrawalYearEagerValidation: true }, () => {
                    this.handleWithdrawalYear(this.state.withdrawalYear);
                });
            }, 1500);
        }

        // pre-decimal formatting method
        let val = e.target.value;

        const startCursorPos = e.target.selectionStart
        const startLength = val.length;

        // strip non-numeric chars except '.'
        val = val.replace(/[^0-9\.]+/g, '');


        // if nothing entered, return investment value to 0
        if (val == '') {
            this.setState({ [rawInvestmentVar]: 0, [investmentVar]: '' }, () => {
                this.validationCheck();

                if (rawInvestmentVar === 'rawSavingsInvestment') {
                    this.handleWithdrawalYear(this.state.withdrawalYear);
                }
            })
            return;
        }        

        // round decimals to 2 places (if exist)
        if (val.split('.')[1] && val.split('.')[1].length > 2) {
            val = parseFloat(val).toFixed(2);
        }

        // format thousands and add currency symbol
        const formattedVal = 'R' + val.replace(/\B(?=(\d{3})+(?!\d))/g, " ");

        const endLength = formattedVal.length;
        const newCursorPos = endLength - startLength + startCursorPos;

        if (val.match(/\d+(?!\w)/) !== null) {
            this.setState({ [rawInvestmentVar]: parseFloat(val), [investmentVar]: formattedVal }, () => {
                e.target.selectionStart = newCursorPos;
                e.target.selectionEnd = newCursorPos;
                this.validationCheck();

                if (rawInvestmentVar === 'rawSavingsInvestment') {
                    this.handleWithdrawalYear(this.state.withdrawalYear);
                }
            });
        }
    }





    handleSalaryValue(e) {

        // pre-decimal formatting method
        let val = e.target.value;

        const startCursorPos = e.target.selectionStart
        const startLength = val.length;

        // strip non-numeric chars except '.'
        val = val.replace(/[^0-9\.]+/g, '');

        // if nothing entered, return investment value to 0
        if (val == '') {
            this.setState({ rawSalaryValue: 0, salaryValue: '' }, () => {
                this.validationCheck();
            })
            return;
        }

        // round decimals to 2 places (if exist)
        if (val.split('.')[1] && val.split('.')[1].length > 2) {
            val = parseFloat(val).toFixed(2);
        }

        // format thousands and add currency symbol
        const formattedVal = 'R' + val.replace(/\B(?=(\d{3})+(?!\d))/g, " ");

        const endLength = formattedVal.length;
        const newCursorPos = endLength - startLength + startCursorPos;

        if (val.match(/\d+(?!\w)/) !== null) {
            this.setState({ rawSalaryValue: parseFloat(val), salaryValue: formattedVal }, () => {
                e.target.selectionStart = newCursorPos;
                e.target.selectionEnd = newCursorPos;
                this.validationCheck();
            });
        }

    }

    handleCurrentAge(e) {
        this.setState({ currentAge: e.target.value }, () => this.validationCheck());

        if (e.target.value < 18 || e.target.value > this.state.retireAge) {
            e.target.classList.add('has-error');
        } else {
            e.target.classList.remove('has-error');
        }
    }

    handleCurrentAgePopUp(e) {
        var popover = bootstrap.Popover.getInstance(document.getElementById('currentAgeInput'))
        if (e.target.value >= 18 && e.target.value <= this.state.retireAge) {
            popover.hide();
        } else {

            if (e.target.value < 18) {
                e.target.setAttribute('data-bs-content', e.target.getAttribute('data-bs-content-min'));
            } else if (e.target.value > this.state.retireAge) {
                e.target.setAttribute('data-bs-content', e.target.getAttribute('data-bs-content-max'));
            }

            popover.show();

            // popovers should be on <a> tags (with a tabindex), this is a work-around to enable them to be dismissable when triggered by other elements
            $('[data-toggle="popover"]').on('shown.bs.popover', function () {
                document.body.addEventListener('click', () => {
                    popover.hide();
                }, { once: true })
            })
        }
    }

    handleLeaveReason(e) {
        this.setState({ leavingReason: e.target.value })
    }

    handleGender(index) {
        this.setState({ gender: index }, () => this.validationCheck())
    }

    // called on radio select and savings component input
    handleWithdrawalYear(index) {
        this.setState({ withdrawalYear: index }, () => this.validationCheck());        

        // only applies to savings component journey
        if (this.props.journey === 2) {          
            
            // clear all errors
            this.setState({ withDrawalYearNextError: false }); 
            this.setState({ withDrawalYearMinError: false }); 
            this.setState({ withDrawalYearMinNote: false });

            // if have withdrawn this year
            if (index === 1) {

                // if savings less than min allowed, show note
                if(this.state.rawSavingsInvestment < this.minSavingsValue && (this.state.rawSavingsInvestment !== 0 || this.state.savingsInvestment !== '')){
                    // eager show error                
                    if (this.state.withDrawalYearEagerValidation) {
                        this.setState({ withDrawalYearMinNote: true }); 
                    }                                
                }


                // if savings more than min, show error
                if(this.state.rawSavingsInvestment >= this.minSavingsValue){
                    this.setState({ withDrawalYearNextError: true }); 
                }
                
                        
            } 

            // if haven't withdrawn this year
            if (index === 0) {

                // if savings less than min allowed, show error
                if(this.state.rawSavingsInvestment < this.minSavingsValue && (this.state.rawSavingsInvestment !== 0 || this.state.savingsInvestment !== '')){

                    // eager show error                
                    if (this.state.withDrawalYearEagerValidation) {
                        this.setState({ withDrawalYearMinError: true });                                       
                    }                    
                } 

                
            }

        }
    }

    handleWithdrawalYearBlur(index) {
        
        if (this.state.withDrawlYearEagerValidation) {           
            this.handleWithdrawalYear(index);          
        } else {
            this.setState({ withDrawalYearEagerValidation: true }, () => {
                this.handleWithdrawalYear(index);
            });
        }
        
    }
    

    handleRetireAge(e) {
        this.setState({ retireAge: e.target.value }, () => this.validationCheck());

        if (e.target.value < 55 || e.target.value > 89) {
            e.target.classList.add('has-error');
        } else {
            e.target.classList.remove('has-error');
        }
    }

    handleRetireAgePopUp(e) {
        var popover = bootstrap.Popover.getInstance(document.getElementById('retAgeInput'))
        if (e.target.value >= 55 && e.target.value <= 89) {
            popover.hide();
        }
        else {

            if (e.target.value < 55) {
                e.target.setAttribute('data-bs-content', e.target.getAttribute('data-bs-content-min'));
            } else if (e.target.value > 89) {
                e.target.setAttribute('data-bs-content', e.target.getAttribute('data-bs-content-max'));
            }

            popover.show();

            // popovers should be on <a> tags (with a tabindex), this is a work-around to enable them to be dismissable when triggered by other elements
            $('[data-toggle="popover"]').on('shown.bs.popover', function () {
                document.body.addEventListener('click', () => {
                    popover.hide();
                }, { once: true })
            })
        }
    }

    handleSalaryValuePopUp(e) {
        var popover = bootstrap.Popover.getInstance(document.getElementById('salaryAmount'));

        if (e.target.value !== '') {
            popover.hide();
        }
        else {   
            popover.show();

            // popovers should be on <a> tags (with a tabindex), this is a work-around to enable them to be dismissable when triggered by other elements
            $('[data-toggle="popover"]').on('shown.bs.popover', function () {
                document.body.addEventListener('click', () => {
                    popover.hide();
                }, { once: true })
            })
        }
    }
   


    validationCheck() {
        let isFormValid = true;
        
        if (this.state.currentAge < 18 || this.state.currentAge > this.state.retireAge) {
            isFormValid = false;
        }
        if (this.state.retireAge < 55 || this.state.retireAge > 89) {
            isFormValid = false;
        }
        if (this.state.rawSalaryValue === 0 && this.state.salaryValue === '') {
            isFormValid = false;
        }
        if (this.state.gender === '') {
            isFormValid = false;
        }
        if (this.state.withdrawalYear === ''){
            isFormValid = false;
        }

        // on exit journey: invalid if...
        if(this.props.journey === 1){

            // both vested amounts are 0 AND either retirement is 0 or savings is blank
            if (this.state.rawVestedInvestment === 0 && this.state.rawVestedHarmonisedInvestment === 0 && (this.state.savingsInvestment === '' || this.state.rawCurrentInvestment === 0) ) {
                isFormValid = false;
            }            


        }
        
        // on savings journey: invalid if...
        if(this.props.journey === 2){

            // savings component amount is 0
            if (this.state.rawSavingsInvestment === 0 ) {
                isFormValid = false;
            }

            // have withdrawn this tax year & savings amount is 2000 or greater
            // OR have not withdrawn, but savings amount is less than 2000
            if ((this.state.withdrawalYear === 1 && this.state.rawSavingsInvestment >= this.minSavingsValue) ||
                (this.state.withdrawalYear === 0 && this.state.rawSavingsInvestment < this.minSavingsValue)) {
                    isFormValid = false;
            }
        }
      
        
        this.setState({ formValid: isFormValid });
        return isFormValid;
    }

    handleForm(e) {
        e.preventDefault();

        if (this.validationCheck()) {

            this.props.setFormValues({
                currentAge: this.state.currentAge,
                retireAge: this.state.retireAge,
                gender: this.state.gender,
                leavingReason: this.state.leavingReason,
                currentInvestment: this.state.rawCurrentInvestment,
                vestedInvestment: this.state.rawVestedInvestment,
                vestedHarmonisedInvestment: this.state.rawVestedHarmonisedInvestment,
                savingsInvestment: this.state.rawSavingsInvestment,                
                salaryValue: this.state.rawSalaryValue,
                withdrawalYear: this.state.withdrawalYear,
                formattedSavingsInvestment: this.state.savingsInvestment
            })
                     

            // scroll to next slide
            const nextSlideIsOpen = document.querySelector('.slide-4') != null
            if (nextSlideIsOpen) {         
                this.props.custScrollTo(document.querySelector('.slide-4'))
            } else {           
                this.props.openNextSlide()
            }

        }
    }



    render() {
        const chevronSVG = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e %3csvg width='8px' height='6px' viewBox='0 0 8 6' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e%3ctitle%3eC3B35B76-2140-4AC7-8E67-7BEB0ECFAC23%3c/title%3e%3cg id='Home' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e%3cg id='1920-Desktop-(1600)---Input-info-dropdown-open' transform='translate(-1341.000000%2c -558.000000)' fill='%2326B0E2'%3e%3cg id='input/default-copy' transform='translate(1074.000000%2c 553.000000)'%3e%3cg id='tooltip/default' transform='translate(271.000000%2c 8.196667) scale(1%2c -1) translate(-271.000000%2c -8.196667) translate(267.000000%2c 5.726667)'%3e%3cpolygon id='%f0%9f%8e%a8-icon-fill' points='7.06 0 4 3.05333333 0.94 0 0 0.94 4 4.94 8 0.94'%3e%3c/polygon%3e%3c/g%3e%3c/g%3e%3c/g%3e%3c/g%3e%3c/svg%3e";
        return (
            <div className="container slide slide-3" ref={this.slide3}>
                <div className="row mx-max-sm-0 justify-content-center">                    
                    <div className="pres-calc-slide__header col-11 col-xl-12">
                        <h2 className="text-red fw-bold font-size-24 font-size-md-32 font-size-xxl-40 text-center cust-mb-26 px-5 cust-px-sm-0">{ this.props.journey === 1 ? this.props.data?.slide3.title : this.props.data?.savingsComponent.slide3.title}</h2>

                        <div className="font-size-16 font-size-md-16 font-size-xxl-18 text-center fw-light text-grey" 
                            dangerouslySetInnerHTML={{ __html: this.props.journey === 1 ? this.props.sanitizeHTML(this.props.data?.slide3.introText)  : this.props.sanitizeHTML(this.props.data?.savingsComponent.slide3.introText) }}>                           
                        </div>

                    </div>                
                </div>
                <form autoComplete="off" onSubmit={(e) => this.handleForm(e)}>
                    <div className="slide3__grid" noValidate>
                        <div className='slide3__age-wrap'>
                            <div className='form-age-field form-age-field--current'>
                                <label htmlFor="currentAgeInput" className="form-label fw-light text-dark-grey font-size-14">Current age</label>
                                <input
                                    type="number"
                                    className="form-control slide3__input ps-3"
                                    id="currentAgeInput"
                                    data-toggle="popover"
                                    data-bs-template="<div class='popover popover--arrowtop in slide3__popover--error' role='tooltip'><div class='arrow'></div><h3 class='popover-header'></h3><div class='popover-body p-0'></div></div>"
                                    data-bs-html="true"
                                    data-bs-trigger="manual"
                                    data-bs-placement="bottom"
                                    data-bs-content="<div></div>"
                                    data-bs-content-min="<div class='d-inline-flex align-items-center'><span class='svgIcon svgIcon--lg svgIcon--alert mr-8'></span> <span class='font-size-12'>You need to be at least 18 years old.</span></div>"
                                    data-bs-content-max="<div class='d-inline-flex align-items-center'><span class='svgIcon svgIcon--lg svgIcon--alert mr-8'></span> <span class='font-size-12'>Your current age cannot exceed your planned retirement age.</span></div>"
                                    onChange={(e) => { this.handleCurrentAge(e) }}
                                    onInput={(e) => { e.target.classList.remove('has-error') }}
                                    onBlur={(e) => { this.handleCurrentAgePopUp(e) }}
                                    value={this.state.currentAge}
                                    min="18"
                                    max="89"
                                    placeholder='0'
                                />
                            </div>
                            <div className='form-age-field form-age-field--retirement'>
                                <a
                                    tabIndex={-1}
                                    className={'hover-none focus-none '}
                                    data-toggle="popover"
                                    data-bs-template="<div class='popover in slide3__popover' role='tooltip'><div class='arrow'></div><h3 class='popover-header'></h3><div class='popover-body p-0'></div></div>"
                                    data-bs-html="true"
                                    data-bs-trigger="focus"
                                    data-bs-placement="bottom"
                                    data-bs-content={`<span class='svgIcon svgIcon--cancel slide3__popover-cancel cursor-pointer'></span><p class='font-size-18 fw-bold text-white mt-0'>Retirement age</p><p class='text-white mb-0'>${this.props.data?.slide3.tooltips.retireAge}</p>`}
                                >
                                    
                                    <label htmlFor="retAgeInput" className="form-label cursor-pointer fw-light text-decoration-underline text-dark-grey font-size-14">Retirement age</label>
                                    <sup className="fw-light text-dark-grey font-size-14">?</sup>
                                </a>
                                <input
                                    type="number"
                                    className={"form-control slide3__input ps-3"}
                                    id="retAgeInput"
                                    data-toggle="popover"
                                    data-bs-template="<div class='popover popover--arrowtop in slide3__popover--error' role='tooltip'><div class='arrow'></div><h3 class='popover-header'></h3><div class='popover-body p-0'></div></div>"
                                    data-bs-html="true"
                                    data-bs-trigger="manual"
                                    data-bs-placement="bottom"
                                    data-bs-content-min="<div class='d-inline-flex align-items-center'><span class='svgIcon svgIcon--lg svgIcon--alert mr-8'></span> <span class='font-size-12'>The minimum retirement age is 55.</span></div>"
                                    data-bs-content-max="<div class='d-inline-flex align-items-center'><span class='svgIcon svgIcon--lg svgIcon--alert mr-8'></span> <span class='font-size-12'>The maximum retirement age is 89.</span></div>"
                                    onChange={(e) => this.handleRetireAge(e)}
                                    onInput={(e) => { e.target.classList.remove('has-error') }}
                                    onBlur={(e) => { this.handleRetireAgePopUp(e) }}
                                    value={this.state.retireAge}
                                    min="55"
                                    max="89"
                                    placeholder='65' />
                            </div>
                        </div>







                        <div className='slide3__check-wrap'>
                            <div className='form-check-field form-check-field--gender'>
                                <a
                                    tabIndex={-1}
                                    className={'hover-none focus-none '}
                                    data-toggle="popover"
                                    data-bs-template="<div class='popover in slide3__popover' role='tooltip'><div class='arrow'></div><h3 class='popover-header'></h3><div class='popover-body p-0'></div></div>"
                                    data-bs-html="true"
                                    data-bs-trigger="focus"
                                    data-bs-placement="bottom"
                                    data-bs-content={`<span class='svgIcon svgIcon--cancel slide3__popover-cancel cursor-pointer'></span><p class='font-size-18 fw-bold text-white mt-0'>Gender</p><p class='text-white mb-0'>${this.props.data?.slide3.tooltips.gender}</p>`}
                                >
                                    <label className="form-label fw-light cursor-pointer text-decoration-underline text-dark-grey font-size-14">Gender</label>
                                    <sup className="fw-light text-dark-grey font-size-14 cursor-pointer">?</sup>
                                </a>
                                <div className="form-check form-check--first d-flex">
                                    <input className="form-check-input cust-mr-1" type="radio" name="genderGroup" id="maleGender" onChange={(e) => this.handleGender(0)} />
                                    <label className="form-check-label font-size-14 fw-normal text-black" htmlFor="maleGender">
                                        Male
                                    </label>
                                </div>
                                <div className="form-check d-flex">
                                    <input className="form-check-input cust-mr-1" type="radio" name="genderGroup" id="femaleGender" onChange={(e) => this.handleGender(1)} />
                                    <label className="form-check-label font-size-14 fw-normal text-black" htmlFor="femaleGender">
                                        Female
                                    </label>
                                </div>
                            </div>
                            
                            <div className='form-check-field form-check-field--withdrawalyear'>
                                
                                {this.props.journey === 1 &&
                                    <label className='form-label fw-light text-dark-grey font-size-14'>
                                        Have you made a withdrawal from your&nbsp;
                                        <a 
                                            tabIndex={-1}
                                            data-toggle="popover"
                                            data-bs-template="<div class='popover in slide3__popover' role='tooltip'><div class='arrow'></div><h3 class='popover-header'></h3><div class='popover-body p-0'></div></div>"
                                            data-bs-html="true"
                                            data-bs-trigger="focus"
                                            data-bs-placement="bottom"
                                            data-bs-content={`<span class='svgIcon svgIcon--cancel slide3__popover-cancel cursor-pointer'></span><p class='font-size-18 fw-bold text-white mt-0'>Savings component</p><p class='text-white mb-0'>${this.props.data?.slide3.tooltips.savingsComponent}</p>`}                                        
                                            className='hover-none focus-none cursor-pointer'>                                            
                                            <span className="text-dark-grey text-decoration-underline">savings component</span>
                                            <sup className="fw-light text-dark-grey font-size-14 cursor-pointer">?</sup>                                            
                                        </a>
                                        in the current tax year?
                                    </label>
                                }

                                {this.props.journey === 2 &&

                                    <label className='form-label fw-light text-dark-grey font-size-14'>
                                        Have you made a withdrawal from your&nbsp;
                                        <a 
                                            tabIndex={-1}
                                            data-toggle="popover"
                                            data-bs-template="<div class='popover in slide3__popover' role='tooltip'><div class='arrow'></div><h3 class='popover-header'></h3><div class='popover-body p-0'></div></div>"
                                            data-bs-html="true"
                                            data-bs-trigger="focus"
                                            data-bs-placement="bottom"
                                            data-bs-content={`<span class='svgIcon svgIcon--cancel slide3__popover-cancel cursor-pointer'></span><p class='font-size-18 fw-bold text-white mt-0'>Savings component</p><p class='text-white mb-0'>${this.props.data?.savingsComponent.slide3.tooltips.savingsComponent}</p>`}                                        
                                            className='hover-none focus-none cursor-pointer'>                                            
                                            <span className="text-dark-grey text-decoration-underline">savings component</span>
                                            <sup className="fw-light text-dark-grey font-size-14 cursor-pointer">?</sup>                                            
                                        </a>
                                        in the current tax year?
                                    </label>
                                }

                                <div className="form-check form-check--first d-flex">
                                    <input className="form-check-input cust-mr-1" type="radio" name="withdrawalYearGroup" id="noWithdrawalYear" onChange={(e) => this.handleWithdrawalYear(0)} />
                                    <label className="form-check-label font-size-14 fw-normal text-black" htmlFor="noWithdrawalYear">
                                        No
                                    </label>
                                </div>
                                <div className="form-check d-flex">
                                    <input className="form-check-input cust-mr-1" type="radio" name="withdrawalYearGroup" id="yesWithdrawalYear" onChange={(e) => this.handleWithdrawalYear(1)}
                                    />
                                    <label className="form-check-label font-size-14 fw-normal text-black" htmlFor="yesWithdrawalYear">
                                        Yes
                                    </label>
                                </div>
                            </div>
                        </div>  
                        

                    </div>
                    <div className="slide3__grid">
                        <div className='form-leaving-field'>
                            {this.props.journey === 1 &&
                                <>
                                    <a
                                        tabIndex={-1}
                                        className={'hover-none focus-none d-block'}
                                        data-toggle="popover"
                                        data-bs-template="<div class='popover in slide3__popover' role='tooltip'><div class='arrow'></div><h3 class='popover-header'></h3><div class='popover-body p-0'></div></div>"
                                        data-bs-html="true"
                                        data-bs-placement="bottom"
                                        data-bs-trigger="focus"
                                        data-bs-content={`<span class='svgIcon svgIcon--cancel slide3__popover-cancel cursor-pointer'></span><p class='font-size-18 fw-bold text-white mt-0'>Reason for leaving your employer</p><p class='text-white mb-0'>${this.props.data?.slide3.tooltips.leavingEmployer}</p>`}
                                    >
                                        <label htmlFor="retAgeInput" className="form-label cursor-pointer fw-light text-decoration-underline text-dark-grey font-size-14">Reason for leaving your employer</label>
                                        <sup className="fw-light text-dark-grey font-size-14 cursor-pointer">?</sup>
                                    </a>
                                    <select className="c-custom-select" value={this.state.leavingReason} onChange={(e) => this.handleLeaveReason(e)}>
                                        {this.state.dropContent.map(option => (
                                            <option value={option.value} key={option.value} className={option.value === 0 ? "hideme" : ""}>{option.text}</option>
                                        ))}
                                    </select>
                                </>
                            }
                            <div className={`value-input-format${this.props.journey === 1 ? ' mt-15' : ''}`}>
                                <div className='value-input-format__label'>
                                    <label
                                        // disabled else it triggers input focus & blur which causes popover to close
                                        // htmlFor="salaryAmount"
                                        className='form-label fw-light text-dark-grey font-size-14'
                                    >
                                        What is your
                                        <a 
                                            tabIndex={-1}
                                            data-toggle="popover"
                                            data-bs-template="<div class='popover in slide3__popover' role='tooltip'><div class='arrow'></div><h3 class='popover-header'></h3><div class='popover-body p-0'></div></div>"
                                            data-bs-html="true"
                                            data-bs-placement="bottom"
                                            data-bs-trigger="focus"
                                            data-bs-content={`<span class='svgIcon svgIcon--cancel slide3__popover-cancel cursor-pointer'></span><p class='font-size-18 fw-bold text-white mt-0'>Annual taxable income</p><p class='text-white mb-0'>${this.props.data?.slide3.tooltips.taxableIncome}</p>`}
                                            className="hover-none focus-none cursor-pointer"> <span className='text-dark-grey text-decoration-underline'>annual taxable income</span></a>
                                        ?
                                    </label>
                                </div>
                                <div className='value-input-format__input'>
                                    <input
                                        type="text"
                                        className="form-control slide3__input ps-3" id="salaryAmount"
                                        value={this.state.salaryValue}
                                        placeholder="R0"
                                        spellCheck="false"
                                        onChange={(e) => this.handleSalaryValue(e)}
                                        onInput={(e) => { e.target.classList.remove('has-error') }}

                                        // required validation message
                                        data-toggle="popover"
                                        data-bs-template="<div class='popover popover--arrowtop in slide3__popover--error' role='tooltip'><div class='arrow'></div><h3 class='popover-header'></h3><div class='popover-body p-0'></div></div>"
                                        data-bs-html="true"
                                        data-bs-trigger="manual"
                                        data-bs-placement="bottom"                                  
                                        data-bs-content="<div class='d-inline-flex align-items-center'><span class='svgIcon svgIcon--lg svgIcon--alert mr-8'></span> <span class='font-size-12'>Please enter an amount</span></div>"                                
                                        onBlur={(e) => { this.handleSalaryValuePopUp(e) }}  
                                    />
                                </div>
                            </div>


                        </div>
                        <div className='form-amounts-fields'>

                            {this.props.journey === 1 &&
                                <>

                                    <div className='value-input-title'>
                                        <span className='fw-light text-dark-grey'>Retirement component breakdown in your Umbrella Fund investment:</span>
                                    </div>

                                    <div className='value-input-format'>
                                        <div className='value-input-format__label mb-5'>
                                            <strong className='text-grey font-size-14 font-title'>Component</strong>
                                        </div>                        
                                        <div className='value-input-format__input mb-5'>
                                            <strong className='text-grey font-size-14 font-title'>Amount</strong>
                                        </div>
                                    </div>

                                </>
                            }

                            <div className='value-input-format'>
                                {this.props.journey === 1 &&
                                    <div className='value-input-format__label'>
                                        <a
                                            tabIndex={-1}
                                            className={'hover-none focus-none '}
                                            data-toggle="popover"
                                            data-bs-template="<div class='popover in slide3__popover' role='tooltip'><div class='arrow'></div><h3 class='popover-header'></h3><div class='popover-body p-0'></div></div>"
                                            data-bs-html="true"
                                            data-bs-placement="bottom"
                                            data-trigger="focus"
                                            data-bs-trigger="focus"
                                            data-bs-content={`<span class='svgIcon svgIcon--cancel slide3__popover-cancel cursor-pointer'></span><p class='font-size-18 fw-bold text-white mt-0'>Savings</p><p class='text-white mb-0'>${this.props.data?.slide3.tooltips.savingsComponent}</p>`}
                                        >
                                            <label htmlFor="savingsBalance" className="form-label cursor-pointer fw-light text-decoration-underline text-dark-grey font-size-14">Savings</label>
                                            <sup className="fw-light text-dark-grey font-size-14 cursor-pointer">?</sup>
                                        </a>
                                    </div>
                                }
                                {this.props.journey === 2 &&
                                    <div className='value-input-format__label'>
                                        <label
                                            // disabled else it triggers input focus & blur which causes popover to close
                                            // htmlFor="savingsBalance"                                            
                                            className='form-label fw-light text-dark-grey font-size-14'                                           
                                        >
                                            <a  
                                            tabIndex={-1}
                                            data-toggle="popover"
                                            data-bs-template="<div class='popover in slide3__popover' role='tooltip'><div class='arrow'></div><h3 class='popover-header'></h3><div class='popover-body p-0'></div></div>"
                                            data-bs-html="true"
                                            data-bs-placement="bottom"
                                            data-trigger="focus"
                                            data-bs-trigger="focus"
                                            data-bs-content={`<span class='svgIcon svgIcon--cancel slide3__popover-cancel cursor-pointer'></span><p class='font-size-18 fw-bold text-white mt-0'>Savings component</p><p class='text-white mb-0'>${this.props.data?.savingsComponent.slide3.tooltips.savingsComponent}</p>`}
                                            className="hover-none focus-none cursor-pointer ">
                                                <span className='text-dark-grey text-decoration-underline'>Savings component</span>
                                                <sup className="fw-light text-dark-grey font-size-14 cursor-pointer">?</sup> 
                                            </a>  
                                            amount                                         
                                        </label>
                                    </div>
                                }
                                <div className='value-input-format__input'>
                                    <input
                                        type="text"
                                        className="form-control slide3__input ps-3" id="savingsBalance"
                                        value={this.state.savingsInvestment}
                                        placeholder="R0"
                                        spellCheck="false"
                                        onChange={(e) => this.handleInvestmentValue(e, 'rawSavingsInvestment', 'savingsInvestment')}
                                        onInput={(e) => { e.target.classList.remove('has-error') }}
                                        onBlur={(e) => this.handleWithdrawalYearBlur(this.state.withdrawalYear)}
                                    />
                                </div>
                            </div>

                            {this.props.journey === 1 &&
                                <div className='value-input-format'>
                                    <div className='value-input-format__label'>
                                        <a
                                            tabIndex={-1}
                                            className={'hover-none focus-none '}
                                            data-toggle="popover"
                                            data-bs-template="<div class='popover in slide3__popover' role='tooltip'><div class='arrow'></div><h3 class='popover-header'></h3><div class='popover-body p-0'></div></div>"
                                            data-bs-html="true"
                                            data-bs-placement="bottom"
                                            data-trigger="focus"
                                            data-bs-trigger="focus"
                                            data-bs-content={`<span class='svgIcon svgIcon--cancel slide3__popover-cancel cursor-pointer'></span><p class='font-size-18 fw-bold text-white mt-0'>Retirement</p><p class='text-white mb-0'>${this.props.data?.slide3.tooltips.retirementComponent}</p>`}
                                        >
                                            <label htmlFor="investmentBalance" className="form-label cursor-pointer fw-light text-decoration-underline text-dark-grey font-size-14">Retirement</label>
                                            <sup className="fw-light text-dark-grey font-size-14 cursor-pointer">?</sup>
                                        </a>
                                    </div>
                                    <div className='value-input-format__input'>
                                        <input
                                            type="text"
                                            className="form-control slide3__input ps-3" id="investmentBalance"
                                            value={this.state.currentInvestment}
                                            placeholder="R0"
                                            spellCheck="false"
                                            onChange={(e) => this.handleInvestmentValue(e, 'rawCurrentInvestment', 'currentInvestment')}
                                            onInput={(e) => { e.target.classList.remove('has-error') }}
                                        />
                                    </div>
                                </div>
                            }

                            {this.props.journey === 1 &&
                                <div className='value-input-format'>
                                    <div className='value-input-format__label'>
                                        <a
                                            tabIndex={-1}
                                            className={'hover-none focus-none '}
                                            data-toggle="popover"
                                            data-bs-template="<div class='popover in slide3__popover' role='tooltip'><div class='arrow'></div><h3 class='popover-header'></h3><div class='popover-body p-0'></div></div>"
                                            data-bs-html="true"
                                            data-bs-placement="bottom"
                                            data-trigger="focus"
                                            data-bs-trigger="focus"
                                            data-bs-content={`<span class='svgIcon svgIcon--cancel slide3__popover-cancel cursor-pointer'></span><p class='font-size-18 fw-bold text-white mt-0'>Vested</p><p class='text-white mb-0'>${this.props.data?.slide3.tooltips.vestedComponent}</p>`}
                                        >
                                            <label htmlFor="vestedBalance" className="form-label cursor-pointer fw-light text-decoration-underline text-dark-grey font-size-14">Vested</label>
                                            <sup className="fw-light text-dark-grey font-size-14 cursor-pointer">?</sup>
                                        </a>
                                    </div>
                                    <div className='value-input-format__input'>
                                        <input
                                            type="text"
                                            className="form-control slide3__input ps-3" id="vestedBalance"
                                            value={this.state.vestedInvestment}
                                            placeholder="R0"
                                            spellCheck="false"
                                            onChange={(e) => this.handleInvestmentValue(e, 'rawVestedInvestment', 'vestedInvestment')}
                                            onInput={(e) => { e.target.classList.remove('has-error') }}
                                        />
                                    </div>
                                </div>
                            }

                            {this.props.journey === 1 &&
                                <div className='value-input-format'>
                                    <div className='value-input-format__label'>
                                        <a
                                            tabIndex={-1}
                                            className={'hover-none focus-none '}
                                            data-toggle="popover"
                                            data-bs-template="<div class='popover in slide3__popover' role='tooltip'><div class='arrow'></div><h3 class='popover-header'></h3><div class='popover-body p-0'></div></div>"
                                            data-bs-html="true"
                                            data-bs-placement="bottom"
                                            data-trigger="focus"
                                            data-bs-trigger="focus"
                                            data-bs-content={`<span class='svgIcon svgIcon--cancel slide3__popover-cancel cursor-pointer'></span><p class='font-size-18 fw-bold text-white mt-0'>Vested harmonised</p><p class='text-white mb-0'>${this.props.data?.slide3.tooltips.vestedHarmonisedComponent}</p>`}
                                        >
                                            <label htmlFor="vestedBalance" className="form-label cursor-pointer fw-light text-decoration-underline text-dark-grey font-size-14">Vested harmonised</label>
                                            <sup className="fw-light text-dark-grey font-size-14 cursor-pointer">?</sup>
                                        </a>
                                    </div>
                                    <div className='value-input-format__input'>
                                        <input
                                            type="text"
                                            className="form-control slide3__input ps-3" id="vestedHarmonisedBalance"
                                            value={this.state.vestedHarmonisedInvestment}
                                            placeholder="R0"
                                            spellCheck="false"
                                            onChange={(e) => this.handleInvestmentValue(e, 'rawVestedHarmonisedInvestment', 'vestedHarmonisedInvestment')}
                                            onInput={(e) => { e.target.classList.remove('has-error') }}
                                        />
                                    </div>
                                </div>
                            }





                            {this.props.journey === 1 &&
                                <>
                                    <p
                                        data-bs-toggle="collapse"
                                        role="button"
                                        data-bs-target="#collapseInfo"
                                        className="font-size-12 text-link-blue mt-4 d-flex align-items-center collapsible"
                                        data-analytics-label="Accordion – Current investment balance"
                                        data-analytics-action="Accordion – Clicked"
                                        data-analytics-category="Preservation calculator"
                                        onClick={(e) => { this.toggleCollapse(); this.props.recordAnalytics(e); }}>
                                        <span>Where can I find my retirement component breakdown?</span>
                                        <img src={chevronSVG} alt="Tooltip Arrow" className={"slide3__collapse ms-3 " + (this.state.collapseOpen ? "slide3__collapse-open" : "")} />
                                    </p>

                                    <div className="collapse" id="collapseInfo">
                                        <div className="font-size-12">
                                            <p className="mb-0">You can find this breakdown of your Allan Gray Umbrella Fund accounts(s) on your:</p>
                                            <ul className="cust-mt-2 list-style-none slide3__list">
                                                <li className="link">
                                                    <a href="https://secure.allangray.co.za/account/signin" target="_blank"
                                                        data-analytics-label="Link -Allan Gray Account"
                                                        data-analytics-action="Link - Clicked"
                                                        data-analytics-category="Preservation calculator"
                                                        className="text-link-blue">Allan Gray Online account</a></li>
                                                <li>Latest quarterly statement</li>                                              
                                            </ul>
                                        </div>
                                    </div>
                                </>
                            }

                            {this.props.journey === 2 &&
                                <>
                                    <p
                                        data-bs-toggle="collapse"
                                        role="button"
                                        data-bs-target="#collapseInfo"
                                        className="font-size-12 text-link-blue mt-4 d-flex align-items-center collapsible"
                                        data-analytics-label="Accordion – Current investment balance"
                                        data-analytics-action="Accordion – Clicked"
                                        data-analytics-category="Preservation calculator"
                                        onClick={(e) => { this.toggleCollapse(); this.props.recordAnalytics(e); }}>
                                        <span>Where can I find my savings component amount?</span>
                                        <img src={chevronSVG} alt="Tooltip Arrow" className={"slide3__collapse ms-3 " + (this.state.collapseOpen ? "slide3__collapse-open" : "")} />
                                    </p>

                                    <div className="collapse" id="collapseInfo">
                                        <div className="font-size-12">
                                            <p className="mb-0">You can find your current savings component amount in your retirement fund account on your:</p>
                                            <ul className="cust-mt-2 list-style-none slide3__list">
                                                <li className="link">
                                                    <a href="https://secure.allangray.co.za/account/signin" target="_blank"
                                                        data-analytics-label="Link -Allan Gray Account"
                                                        data-analytics-action="Link - Clicked"
                                                        data-analytics-category="Preservation calculator"
                                                        className="text-link-blue">Allan Gray Online account</a></li>
                                                <li>Latest quarterly statement</li>                                                
                                            </ul>
                                        </div>
                                    </div>
                                </>
                            }
                        </div>
                    </div>

                    {this.state.withDrawalYearNextError &&
                        <div className="slide3__note">
                           
                                <div className="form-note-field font-size-14 font-size-md-16  text-center fw-light text-grey" dangerouslySetInnerHTML={{ __html: this.props.sanitizeHTML(this.props.data?.savingsComponent.slide3.validation.withDrawalYearNextError)}}>
                                </div>
                       
                        </div>
                    }

                    {this.state.withDrawalYearMinError &&
                        <div className="slide3__note">
                           
                                <div className="form-note-field font-size-14 font-size-md-16  text-center fw-light text-grey" dangerouslySetInnerHTML={{ __html: this.props.sanitizeHTML(this.props.data?.savingsComponent.slide3.validation.withDrawalYearMinError)}}>
                                </div>
                         
                        </div>
                    }

                    {this.state.withDrawalYearMinNote &&
                        <div className="slide3__note">
                           
                                <div className="form-note-field font-size-14 font-size-md-16  text-center fw-light text-grey" dangerouslySetInnerHTML={{ __html: this.props.sanitizeHTML(this.props.data?.savingsComponent.slide3.validation.withDrawalYearMinNote)}}>
                                </div>
                         
                        </div>
                    }

                    <div className="row justify-content-center cta-row cust-mt-5">

                        <div className='col-0 col-sm-6'></div>
                        <div className="col-12 col-sm-6">
                            <div className="d-flex justify-content-end">
                                <button className="btn btn-primary btn-red mb-4 btn--greytext" type="submit" 
                                    disabled={!this.state.formValid}                                
                                    >See my results</button>
                            </div>
                        </div>
                    </div>
                </form>

            </div>
        )
    }
}

export default Slide3;
